import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider, useColorScheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import PropTypes from 'prop-types';

import getDesignTokens from '../assets/theme';

const AppContext = React.createContext({
  toggleColorMode: () => {},
});

const useAppContext = () => React.useContext(AppContext);

const AppContextProvider = ({ children }) => {
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const { mode, systemMode, setMode } = useColorScheme();
  const activeMode = mode === 'system' ? systemMode : mode;

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode(activeMode === 'dark' ? 'light' : 'dark');
      },
    }),
    [activeMode, setMode],
  );

  return (
    <AppContext.Provider value={{ colorMode, mode: activeMode, reducedMotion: prefersReducedMotion }}>
      {children}
    </AppContext.Provider>
  );
};

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const theme = createTheme(getDesignTokens());

const AppProvider = ({ children }) => (
  <ThemeProvider
    theme={theme}
    defaultMode="system"
    disableTransitionOnChange
    forceThemeRerender
  >
    <CssBaseline />
    <AppContextProvider>{children}</AppContextProvider>
  </ThemeProvider>
);

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AppProvider, useAppContext };
